var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer py-40 py-md-52"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "flex-column-reverse flex-lg-row",
    attrs: {
      "justify-lg": "space-between",
      "align-lg": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "10"
    }
  }, [_c('p', {
    staticClass: "font-weight-bold font-size-14 font-size-lg-16 mb-10 mb-lg-0"
  }, [_vm._v(" Meitextile co., ltd. ")]), _c('div', {
    staticClass: "d-md-flex mb-6 mb-lg-8 flex-wrap"
  }, [_c('p', {
    staticClass: "mb-2 mb-0 mr-md-8 mr-lg-18"
  }, [_vm._v(" ADDRESS. "), _c('span', [_vm._v("[04927] 서울특별시 광진구 능동로 344번지")])]), _c('p', {
    staticClass: "mb-2 mb-0 mr-md-8 mr-lg-18"
  }, [_vm._v(" TEL. "), _c('span', [_vm._v("02 752 9510")])]), _c('p', {
    staticClass: "mb-2 mb-0 mr-md-8 mr-lg-18"
  }, [_vm._v(" FAX. "), _c('span', [_vm._v("02 706 1649")])]), _c('p', [_vm._v(" EMAIL. "), _c('span', [_vm._v("Meitex@meitex.co.kr")])])]), _c('p', [_c('span', [_vm._v("© 2022. Meitextile co., ltd. All rights reserved")])])]), _c('v-col', {
    staticClass: "d-flex justify-lg-end mb-24 mb-lg-0",
    attrs: {
      "cols": "8",
      "sm": "5",
      "lg": "2"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/ci-dark.svg",
      "contain": "",
      "max-width": "220"
    }
  })], 1)], 1)], 1), _c('u-scroll-top')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }